import { render, staticRenderFns } from "./WServiceMaterialForm.vue?vue&type=template&id=7588c18c&"
import script from "./WServiceMaterialForm.vue?vue&type=script&lang=js&"
export * from "./WServiceMaterialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports